// Search Boards
export const SEARCH_BOARDS_REQUEST = 'SEARCH_BOARDS_REQUEST';
export const SEARCH_BOARDS_SUCCESS = 'SEARCH_BOARDS_SUCCESS';
export const SEARCH_BOARDS_FAILURE = 'SEARCH_BOARDS_FAILURE';

// Fetch Board by ID
export const FETCH_BOARD_REQUEST = 'FETCH_BOARD_REQUEST';
export const FETCH_BOARD_SUCCESS = 'FETCH_BOARD_SUCCESS';
export const FETCH_BOARD_FAILURE = 'FETCH_BOARD_FAILURE';

// Create Board
export const CREATE_BOARD_REQUEST = 'CREATE_BOARD_REQUEST';
export const CREATE_BOARD_SUCCESS = 'CREATE_BOARD_SUCCESS';
export const CREATE_BOARD_FAILURE = 'CREATE_BOARD_FAILURE';

// Update Board
export const UPDATE_BOARD_REQUEST = 'UPDATE_BOARD_REQUEST';
export const UPDATE_BOARD_SUCCESS = 'UPDATE_BOARD_SUCCESS';
export const UPDATE_BOARD_FAILURE = 'UPDATE_BOARD_FAILURE';

// Delete Board
export const DELETE_BOARD_REQUEST = 'DELETE_BOARD_REQUEST';
export const DELETE_BOARD_SUCCESS = 'DELETE_BOARD_SUCCESS';
export const DELETE_BOARD_FAILURE = 'DELETE_BOARD_FAILURE';

// Reset States
export const RESET_BOARD_STATE = 'RESET_BOARD_STATE';

// Action Creators
export const searchBoardsRequest = (params) => ({
    type: SEARCH_BOARDS_REQUEST,
    payload: params
});

export const fetchBoardRequest = (id) => ({
    type: FETCH_BOARD_REQUEST,
    payload: id
});

export const createBoardRequest = (data) => ({
    type: CREATE_BOARD_REQUEST,
    payload: data
});

export const updateBoardRequest = (id, data) => ({
    type: UPDATE_BOARD_REQUEST,
    payload: { id, data }
});

export const deleteBoardRequest = (id) => ({
    type: DELETE_BOARD_REQUEST,
    payload: id
});

export const resetBoardState = () => ({
    type: RESET_BOARD_STATE
});
